export default defineNuxtRouteMiddleware(() => {
  const { isAuthenticated } = useAuth()
  const config = useRuntimeConfig()

  if (isAuthenticated.value) {
    return navigateTo(config.public.api.redirects.onGuestOnly, { replace: true })
  }
})
